import { render, staticRenderFns } from "./OrderPurchaseItemSO.vue?vue&type=template&id=68b1d402"
import script from "./OrderPurchaseItemSO.vue?vue&type=script&lang=js"
export * from "./OrderPurchaseItemSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b1d402')) {
      api.createRecord('68b1d402', component.options)
    } else {
      api.reload('68b1d402', component.options)
    }
    module.hot.accept("./OrderPurchaseItemSO.vue?vue&type=template&id=68b1d402", function () {
      api.rerender('68b1d402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Application/Orders/components/OrderPurchaseItemSO.vue"
export default component.exports